"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _iterableToArrayLimit;

var _getIterator2 = _interopRequireDefault(require("../../core-js/get-iterator"));

var _isIterable2 = _interopRequireDefault(require("../../core-js/is-iterable"));

var _symbol = _interopRequireDefault(require("../../core-js/symbol"));

function _iterableToArrayLimit(arr, i) {
  if (typeof _symbol.default === "undefined" || !(0, _isIterable2.default)(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = (0, _getIterator2.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}